<script>
  import {
    VCardText
  } from 'vuetify/lib'
  export default {
    name: 'wh-card-text',
    extends: VCardText
  };
</script>